<template>
    <div>
        <div class="title">
            <span>
                双十一活动红包海报制作
            </span>
        </div>
        <div style="margin-top: 20px">
            <van-notice-bar
                    color="#1989fa"
                    background="#ecf9ff"
            >
                第一步: 从下方选择推广的活动
            </van-notice-bar>
        </div>
        <van-dropdown-menu active-color="#ee0a24">
            <van-dropdown-item v-model="select" :options="selectOption" @change="onSelect"/>
        </van-dropdown-menu>

        <div style="margin-top: 20px">
            <van-notice-bar
                    color="#1989fa"
                    background="#ecf9ff"
            >
                第二步: 长按下方海报图进行分享
            </van-notice-bar>
        </div>
        <van-panel style="margin: 5px">
            <div slot="header" style="display: none"></div>
<!--            <van-overlay :show="show"/>-->
            <div v-if="showLoading" style="text-align: center" ref="loading">
                <van-loading size="24px">加载中...</van-loading>
            </div>
            <div>
                <div id="content" ref="contentDiv"
                     class="content_div"
                     :style="{width:'100%',height: backHeight+'px'}"
                >

                    <img id="posterImg"
                         ref="posterImgEl"
                         class="center_"
                         :src="eventBean.posterImage"
                         width="100%"
                         @load="loadImage"
                    />
                    <div id="text"
                         ref="textDiv"
                         class="left_bottom"
                         :style="{top: qr_top}"
                         v-if="showText">
                        <div class="left_name">{{eventBean.name}}</div>
                        <div class="left_desc">{{eventBean.desc}}</div>
                    </div>
                    <div id="qrCode"
                         ref="qrCodeDiv"
                         class="right_bottom"
                         :style="{left:qr_left - 5 +'px',top: qr_top+'px'}">
                    </div>
                    <div class="qrcode_txt" :style="{width:qr_width+'px', left:qr_left + 'px',top: qr_top+qr_width+15+'px'}">
                        长按识别领取红包
                    </div>


                </div>
                <div id="poster" ref="posterDiv">
                    <img id="share_img" ref="shareImg"/>
                </div>
                <div ref="posterDiv_bak">

                </div>

                <div ref="overlay" v-if="$refs.contentDiv" :style="{width: overlay_width,
                height: overlay_height, backgroundColor: '#00000099',
                position: 'absolute', top: overlay_top, display:'none'}"></div>
            </div>

        </van-panel>

    </div>
</template>

<script>

    import QRCode from 'qrcodejs2';
    import html2canvas from 'html2canvas';

    export default {
        name: "Wp_jd_events",
        data() {
            return {
                screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,     // 屏幕宽
                screeHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,    // 屏幕高
                qr_width: 120,
                qr_left: '100',
                qr_top: '200',
                backWidth: 0,
                backHeight: 0,
                select: "1001",
                selectOption: [],
                eventBean: {
                    id: '',
                    name: '',
                    desc: '',
                    materialUrl: '',
                    posterImage: '',
                    shortUrl: '',
                },
                showLoading: false,
                showText: false,
                channelName: '',
                show:false,

                overlay_width: '0px',
                overlay_height: '0px',
                overlay_top : '0px',
            }
        },
        created() {
            this.$log("created");
            this.loadEventList();
            // this.$log("screenWidth:" + this.screenWidth + "  screeHeight:" + this.screeHeight)
            this.backWidth = this.screenWidth;
            this.backHeight = this.screeHeight;
            this.channelName = this.$store.state.username;
            this.loadEventUrl();
        },
        beforeCreate(){
           this.$log("beforeCreate")
        },
        methods: {
            loadEventList() {
                let that = this;
                let _params = {};
                this.$getEventsApi(_params, function (response) {
                    let list = response.data;
                    if (list.length > 0) {
                        that.select = list[0].id;
                        for (let i in list) {
                            let item = list[i];
                            let _data = {text: item.name, value: item.id};
                            that.selectOption.push(_data);
                        }
                    }
                })
            },
            loadEventUrl() {
                let that = this;
                if (this.select) {
                    let _params = {
                        id: this.select,
                        channel_name: this.channelName
                    };
                    this.$getEventsApi(_params, function (response) {
                        let _data = response.data;
                        that.eventBean = _data;
                        if (that.eventBean) {
                            let contentDiv = that.$refs.contentDiv;
                            contentDiv.hidden = false;
                            // this.$log('-开始加载图片-');

                            that.showLoading = true;

                        }
                    })
                }
            },
            makeQRCode(url) {
                let qrCode = this.$refs.qrCodeDiv;
                qrCode.innerHTML = '';//清空
                new QRCode(qrCode, {
                    text: url,
                    width: this.qr_width,
                    height: this.qr_width,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                });
            },

            loadImage() {
                // this.$log('==图片加载完成==');
                this.show=true;
                let posterImg = this.$refs.posterImgEl;

                // $refs.contentDiv.style.height

                // this.$log(posterImg.width);
                // this.$log(posterImg.height);
                let backH = posterImg.height / posterImg.width;

                this.backWidth = this.screenWidth - 10;//因为外层margin为5px，左右两边加一起10px，需要减去
                this.backHeight = this.backWidth * backH;

                this.overlay_width = this.backWidth;
                //显示遮罩层
                this.$refs.overlay.style.display = 'block';

                if (this.backWidth > this.backHeight) {
                    this.backHeight = this.backHeight + 110;
                    this.qr_top = posterImg.height-this.qr_width-40;
                    this.qr_left = this.backWidth - this.qr_width - 20;
                    this.showText = true;
                } else {
                    this.qr_left = (this.screenWidth - this.qr_width) / 2;
                    // this.qr_top = '80%';
                    this.qr_top = posterImg.height-this.qr_width-50;
                    this.showText = false;
                }
                this.makeQRCode(this.eventBean.shortUrl);
                let that = this;
                setTimeout(function () {
                    that.html2Img();
                }, 200);

            },

            html2Img() {
                let that= this;
                // let contentDiv = document.querySelector("#content");
                let domObj = this.$refs.contentDiv;
                let scroll_1 = document.documentElement.scrollTop;
                let scroll_2 = window.pageYOffset;
                let scroll_3 = document.body.scrollTop;

                document.documentElement.scrollTop = 0;
                window.pageYOffset = 0;
                document.body.scrollTop = 0;


                html2canvas(domObj, {
                    allowTaint: true, //允许污染
                    taintTest: true, //在渲染前测试图片(没整明白有啥用)
                    useCORS: true, //使用跨域(当allowTaint为true时这段代码没什么用)
                    // onclone(doc) {
                    //     let e = doc.querySelector('#content');
                    // }
                }).then(canvas => {
                    let base64_data = canvas.toDataURL();
                    if (base64_data) {
                        domObj.hidden = true;
                        that.show=false;
                        let shareImg = this.$refs.shareImg;
                        if (shareImg) {
                            shareImg.style = 'width:100%;';
                            shareImg.style.height = this.backHeight;
                            shareImg.src = base64_data;
                            shareImg.name = "preview";
                        } else {

                            let posterDiv_bak = this.$refs.posterDiv_bak;
                            if(posterDiv_bak){

                                this.resetChilds(posterDiv_bak);

                                let img = new Image();
                                img.style = "width:100%;";
                                img.name = "share";
                                img.class = "pop_img";
                                img.src = base64_data;
                                // document.body.appendChild(img);

                                posterDiv_bak.appendChild(img);
                            }else{
                                this.$dialog.alert({
                                    message: "海报制作出错，请刷新页面重新"
                                }).then(()=>{
                                    // this.$router.go(0);
                                    window.location.reload();
                                })
                            }

                        }
                        that.showLoading = false;
                        // this.showImg(true, base64_data);
                        // this.show = true;

                        //隐藏遮罩层
                        this.$refs.overlay.style.display = 'none';
                    }
                });
                document.documentElement.scrollTop = scroll_1;
                window.pageYOffset = scroll_2;
                document.body.scrollTop = scroll_3;
            },
            onSelect(value) {
                // this.$log(value);
                let shareImg = this.$refs.shareImg;
                if (shareImg) {
                    shareImg.src = '';
                    shareImg.style.height = '0px';
                }
                let posterDiv_bak = this.$refs.posterDiv_bak;
                if(posterDiv_bak){
                    this.resetChilds(posterDiv_bak);
                }
                this.showLoading = true;
                this.select = value;
                this.loadEventUrl()
            },

            resetChilds(parent) {
                let child = parent.lastElementChild;
                while (child) {
                    parent.removeChild(child);
                    child = parent.lastElementChild;
                }
            }
        },
        watch:{
            backHeight(newValue){
                this.overlay_width = this.backWidth + "px";
                this.overlay_height = newValue + "px";
            },
            showLoading(newValue){
                if(newValue){
                    this.overlay_top = "24px";
                }else{
                    this.overlay_top = "0px";
                }
            }
        }
    }
</script>

<style scoped>
    .title {
        color: red;
        margin-top: 20px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
    }

    .content_div {
        /*width:'100%';*/
        /*position: absolute;*/
        /*overflow: hidden;*/
        /*background-color: #5b6270;*/
        /*background-color: #f2f4f5;*/
    }

    .content_div .center_ {
        position: absolute;
    }

    .content_div .right_bottom {
        position: absolute;
        padding: 0px auto;
        border: 5px solid rgb(255, 255, 255);
        width: 130px;
        height: 130px;
        border-radius: 5px;
    }

    .content_div .qrcode_txt {
        position: absolute;
        text-align: center;
        color: white;
        /*color: lightgray;*/
        font-size: 14px;
        font-weight: bold;
    }

    .content_div .left_bottom {
        color: #323233;
        font-size: 18px;
        width: 70%;
        position: absolute;
        left: 10px;
    }

    .content_div .left_name {
        font-size: 18px;
        font-weight: bold;
    }

    .content_div .left_desc {
        font-size: 14px;
        color: red;
    }

</style>